import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 
    "depositCheckbox", "depositAmountField" ]

  connect() {
    
  }

  toggleDepositAmount() {
    const checkbox = this.depositCheckboxTarget;
    const amountField = this.depositAmountFieldTarget;
    
    if (checkbox.checked) {
      amountField.style.display = 'block';
    } else {
      amountField.style.display = 'none';
    }
  }

}

